/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageComparison/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CloseAction from './CloseAction/index'
import Content from './Content/index'
import FullScreenButton from 'DesignSystem/FullScreenButton/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import Orientation from './Orientation/index'
import React from 'react'
import Title from 'DesignSystem/Title/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ImageComparison({
  children,
  viewPath = "/DesignSystem/ImageComparison",
  onClose
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 id="imagecomparison"
 width="calc(100vw - 30px)"
 height="calc(100vh - 30px)"
 paddingTop={dtSpaceS}
 paddingBottom={dtSpaceS}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
>
{childProps => (
<React.Fragment>
<div
  data-testid="ImageComparison.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-1nC1G7': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="ImageComparison.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mr-2-1nC1G7': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Title
  viewPath={`${viewPath}/Title`}
 text="Compare images"
/>
<Orientation
  viewPath={`${viewPath}/Orientation`}
/>
</div>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
 onClose={onClose}
/>
</div>
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
<div
  data-testid="ImageComparison.Horizontal:2"
  data-view-path={viewPath}
 style={{'--mt-3-1nC1G7': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mb-1-1nC1G7': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<FullScreenButton
  viewPath={`${viewPath}/FullScreenButton`}
/>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 marginLeft={dtSpaceXs}
 onClick={onClose}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Close"
/>
)}
</TysiaButton>
</div>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}